angular.module 'zc.master.users', [
  'zc.master'
]




// WEBPACK FOOTER //
// ./src/master_admin_modules/master.users/index.js.coffee